export default __webpack_public_path__ + "static/media/logo-2.fb686d97.svg";